import { gql } from "@apollo/client";

export const CREATE_AND_UPDATE_EVALUACION_PACIENTE = gql`
mutation CreateAndUpdateEvaluacionPaciente($input: AddEvaluacionPacienteInput!) {
    createAndUpdateEvaluacionPaciente(input: $input){
        idEvaluacion
    }
}
`;